<template>
  <div v-if="inventarisatie">
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>10 europese aanbevelingen en ARBO</b-card-title>          
          </b-card-header>
          <b-card-body>
            <b-form-group 
              v-for="(item,index) in europeseAanbevelingen" 
              :key="index"
            >
              <b-input-group>
                <b-radio-group 
                  v-model="inventarisatie[item.code]" 
                  :options="opties" 
                  buttons
                />
                <b-input-group-text>
                  {{ item.label }}
                </b-input-group-text>
              </b-input-group>
            </b-form-group>
              
            <b-form-group label="Arbo-veilig">
              <b-input-group>
                <b-radio-group 
                  v-model="inventarisatie.ARBO" 
                  :options="opties" 
                  buttons
                />
                <b-input-group-text>
                  Installatie geheel ARBO-veilig
                </b-input-group-text>
              </b-input-group>
            </b-form-group>
          </b-card-body>
          <b-card-footer>
            <b-button 
              :disabled="isBusy || inventarisatie == null" 
              variant="success" 
              @click="opslaanInventarisatie(inventarisatie)"
            >
              Opslaan
            </b-button>
            {{ boodschap }}
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card 
          no-body
        >
          <b-card-header>
            <b-card-title>Technische data info</b-card-title>          
          </b-card-header>
          <b-card-body>
            <b-textarea 
              v-model="inventarisatie.TDI" 
              rows="15"
            />
            <b-button
              :disabled="isBusy"
              class="mt-2"
              variant="success"
              @click="opslaanInventarisatie(inventarisatie)"
            >
              <i 
                v-if="!isBusy" 
                class="fa fa-save mx-1"
              />
              <b-spinner
                v-else
                :small="true"
                size="sm"
                class="mx-1"
                role="status"
                variant="secondary"
              />Opslaan Technische data info
            </b-button>
            <br>
            <small>{{ boodschap }}</small>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col 
        v-for="(element,index) in unitElementen" 
        v-show="element.Form.group" 
        :key="index" 
        md="4"
      >
        <element-card 
          :title="element.Naam" 
          :form="element.Form" 
          :data="inventarisatie"
        >
          <b-badge class="pull-right">
            {{ element.Code }}
          </b-badge>
        </element-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ElementCard from "@/components/ElementCard";
import { elementenMixin } from "@/mixins/elementenMixin";
export default {
  components: {ElementCard},
  mixins: [elementenMixin],
  props: {
    unit: { type: Object,default: null }
  },
  data() {
    return {
      boodschap: "...",
      europeseAanbevelingen: [
        {code: 'MCAS', label: 'Materiële cabine-afsluiting+standaanduiding'},
        {code: 'PCDS', label: 'Periodieke controle draag-staalkabels'},
        {code: 'SVR', label: 'Stopverschillen verbeteren (regeling)'},
        {code: 'SVEN', label: 'Signalering volgens NEN-EN 81-70'},
        {code: 'LOC', label: 'Lichtsensorlijst op cabinetoegang(EN)'},
        {code: 'VNOL', label: 'Vang neerwaars op lift bij v>0f= 0,6 m/s'},
        {code: 'SLV', label: 'Spreek-/luisterverbinding (intercom)'},
        {code: 'CVAS', label: 'Contr./verwijderen asbesth. remvoering'},
        {code: 'VOO', label: 'Vang tbv ongecontr. opwaartse bew.kooi'},
        {code: 'NIDC', label: 'Noodverlichting in de cabine'}
      ],
      opties: ['ja','nee','nvt']
    }
  },
  computed: {
    unitElementen: function() {
      return this.elementKeys.map(e => this.elementen[e]);
    },
    elementKeys: function() {
      return Object.keys(this.elementen).filter(e => this.unit.Elementen.includes(this.elementen[e].Code));
    },
    prognoseUrl: function() {
      return "/unit/" + this.$props.unit.Id + "/inventarisatie";
    }
  },
  watch: {
    unit: {
      handler: function () {
        this.loadElementen();
        this.loadInventarisatie();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadElementen();
    this.loadInventarisatie();
  },
};
</script>